import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from '../components/Footer';
import Header from '../components/Header';

const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>404 Bulunamadı - Legalbul</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            
            <Header />
            <div className="m-5" style={{ minHeight: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="prose container bg-white shadow text-center" style={{ padding: '2rem' }}>
                    <h1 className="text-orange">404 - Aradığınız Sayfa Bulunamadı</h1>
                    <p>Üzgünüz, bir sorun oluştu.</p>
                    <Link to="/">
                        <button className="btn btn-primary" style={{ backgroundColor: 'var(--blue-color) !important', borderColor: 'var(--blue-color) !important' }}>Ana sayfaya dönmek için tıklayınız</button>
                    </Link>
                </div>
            </div>
            
            <Footer />
        </>
    );
};

export default React.memo(NotFound);
